import { render } from "./SelectBox.vue?vue&type=template&id=54cc038d"
import script from "./SelectBox.vue?vue&type=script&lang=js"
export * from "./SelectBox.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__